import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';

export const Container = styled.div`
  position: relative;
`;
export const AlertContainer = styled(Grid)`
  position: absolute;
  top: 0;
  right: 0;
  min-width: 50%;
`;

export const SectionTitle = styled(Typography)`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
`;

export const SectionHeader = styled(Grid)`
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  padding: 14px 0px 14px 0px;
  gap: 20px;
  border-bottom: 1px solid ${colors.gray900};
`;

export const ItemLabel = styled(Typography)`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
`;
export const ItemValue = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
`;
